// EFM case types per category (LA County)
// This data is county-specific and will eventually come from the EFM API
export const LA_COUNTY_CASE_TYPES = {
    // Appellate — 4 types
    'AP': [
        { code: 'AP6154O', name: 'Appellate Division Pre-Appeal Motion', categoryCode: 'AP' },
        { code: 'AP6155', name: 'Petition for Writ - Habeas Corpus', categoryCode: 'AP' },
        { code: 'AP6152', name: 'Petition for Writ - Mandate', categoryCode: 'AP' },
        { code: 'AP6153', name: 'Petition for Writ - Other', categoryCode: 'AP' },
    ],
    // Civil Limited — 56 types
    'LC': [
        { code: '2002', name: 'Abstract of Judgment', categoryCode: 'LC' },
        { code: '2004', name: 'Administrative Agency Award', categoryCode: 'LC' },
        { code: '3902', name: 'Administrative Hearing', categoryCode: 'LC' },
        { code: '0301', name: 'Antitrust/Trade Regulation', categoryCode: 'LC' },
        { code: '0401', name: 'Asbestos Property Damage', categoryCode: 'LC' },
        { code: '0501', name: 'Asset Forfeiture Case', categoryCode: 'LC' },
        { code: '0601', name: 'Breach of Rental/Lease Contract', categoryCode: 'LC' },
        { code: '0801', name: 'Civil Rights/Discrimination', categoryCode: 'LC' },
        { code: '4001', name: 'Claims Involving Mass Tort', categoryCode: 'LC' },
        { code: '0903', name: 'Collections Case - Purchased Debt', categoryCode: 'LC' },
        { code: '0901', name: 'Collections Case - Seller Plaintiff', categoryCode: 'LC' },
        { code: '2307', name: 'Construction Accidents', categoryCode: 'LC' },
        { code: '1001', name: 'Construction Defect', categoryCode: 'LC' },
        { code: '0602', name: 'Contract/Warranty Breach - Seller Plaintiff', categoryCode: 'LC' },
        { code: '3701', name: 'Contractual Fraud', categoryCode: 'LC' },
        { code: '1301', name: 'Defamation', categoryCode: 'LC' },
        { code: '4303', name: 'Elder Abuse/Dependent Adult Abuse Case', categoryCode: 'LC' },
        { code: '2305', name: 'Elder/Dependent Adult Abuse/Claims against Skilled Nursing Facility', categoryCode: 'LC' },
        { code: '1401', name: 'Eminent Domain/Condemnation', categoryCode: 'LC' },
        { code: '1601', name: 'Fraud no contract', categoryCode: 'LC' },
        { code: '4202', name: 'Injunctive Relief Only', categoryCode: 'LC' },
        { code: '1801', name: 'Insurance Coverage not complex', categoryCode: 'LC' },
        { code: '2302', name: 'Intentional Bodily Injury/Property Damage/Wrongful Death', categoryCode: 'LC' },
        { code: '2306', name: 'Intentional Conduct - Sexual Abuse Case', categoryCode: 'LC' },
        { code: '2303', name: 'Intentional Infliction of Emotional Distress', categoryCode: 'LC' },
        { code: '2308', name: 'Landlord-Tenant Habitability', categoryCode: 'LC' },
        { code: '2501', name: 'Legal Malpractice', categoryCode: 'LC' },
        { code: '4501', name: 'Medical Malpractice - Physicians & Surgeons', categoryCode: 'LC' },
        { code: '2601', name: 'Mortgage Foreclosure', categoryCode: 'LC' },
        { code: '2201', name: 'Motor Vehicle - PI/PD/WD', categoryCode: 'LC' },
        { code: '0603', name: 'Negligent Breach of Contract/Warranty', categoryCode: 'LC' },
        { code: '0604', name: 'Other Breach of Contract/Warranty', categoryCode: 'LC' },
        { code: '4307', name: 'Other Civil Petition', categoryCode: 'LC' },
        { code: '4203', name: 'Other Commercial Complaint', categoryCode: 'LC' },
        { code: '0701', name: 'Other Commercial/Business Tort', categoryCode: 'LC' },
        { code: '4204', name: 'Other Complaint', categoryCode: 'LC' },
        { code: '3703', name: 'Other Contract Dispute', categoryCode: 'LC' },
        { code: '1501', name: 'Other Employment Complaint', categoryCode: 'LC' },
        { code: '2006', name: 'Other Enforcement of Judgment', categoryCode: 'LC' },
        { code: '3501', name: 'Other Non-PI/PD tort', categoryCode: 'LC' },
        { code: '2304', name: 'Other PI/PD/WD', categoryCode: 'LC' },
        { code: '4502', name: 'Other Professional Health Care Malpractice', categoryCode: 'LC' },
        { code: '2502', name: 'Other Professional Malpractice', categoryCode: 'LC' },
        { code: '0902', name: 'Other Promissory Note/Collections', categoryCode: 'LC' },
        { code: '2603', name: 'Other Real Property', categoryCode: 'LC' },
        { code: '3901', name: 'Other Writ/Judicial Review', categoryCode: 'LC' },
        { code: '3903', name: 'Parking Appeal', categoryCode: 'LC' },
        { code: '4601', name: 'PI/PD/WD - Uninsured Motorist', categoryCode: 'LC' },
        { code: '1101', name: 'Petition to Compel/Confirm/Vacate Arbitration', categoryCode: 'LC' },
        { code: '2005', name: 'Petition/Certificate for Entry Judgment on Unpaid Tax', categoryCode: 'LC' },
        { code: '2301', name: 'Premise Liability', categoryCode: 'LC' },
        { code: '2402', name: 'Product Liability - Lemon Law', categoryCode: 'LC' },
        { code: '2401', name: 'Product Liability', categoryCode: 'LC' },
        { code: '2602', name: 'Quiet Title', categoryCode: 'LC' },
        { code: '2801', name: 'Securities Litigation', categoryCode: 'LC' },
        { code: '2001', name: 'Sister State Judgment', categoryCode: 'LC' },
        { code: '3702', name: 'Tortious Interference', categoryCode: 'LC' },
        { code: '3801', name: 'Unlawful Detainer - Drugs', categoryCode: 'LC' },
        { code: '3401', name: 'Unlawful Detainer - Post-Foreclosure', categoryCode: 'LC' },
        { code: '3101', name: 'Unlawful Detainer/Commercial', categoryCode: 'LC' },
        { code: '3201', name: 'Unlawful Detainer/Residential', categoryCode: 'LC' },
        { code: '3301', name: 'Wrongful Eviction', categoryCode: 'LC' },
        { code: '3601', name: 'Wrongful Termination', categoryCode: 'LC' },
    ],
    // Civil Restraining Order — 4 types
    '21': [
        { code: '68054', name: 'Civil Harassment Prevention', categoryCode: '21' },
        { code: '58367', name: 'Gun Violence Restraining Order', categoryCode: '21' },
        { code: '68062', name: 'School Violence Prevention', categoryCode: '21' },
        { code: '68064', name: 'Workplace Violence Prevention', categoryCode: '21' },
    ],
    // Family — 36 types
    '12': [
        { code: '104163', name: 'Adoption: Dependent - Minor', categoryCode: '12' },
        { code: '104162', name: 'Adoption: Dependent - Non-Minor Dependent', categoryCode: '12' },
        { code: '101277', name: 'Adoption: FL - Adult', categoryCode: '12' },
        { code: '101278', name: 'Adoption: FL - Independent', categoryCode: '12' },
        { code: '101279', name: 'Adoption: FL - Agency - Domestic', categoryCode: '12' },
        { code: '101280', name: 'Adoption: FL - Agency - International IR-3/IH-3', categoryCode: '12' },
        { code: '101281', name: 'Adoption: FL - Agency - International IR-4/IH-4', categoryCode: '12' },
        { code: '101282', name: 'Adoption: FL - Step-Parent', categoryCode: '12' },
        { code: '68053', name: 'Approval of Minor\'s Contract', categoryCode: '12' },
        { code: '68055', name: 'Consent for Minor to Marry/Establish Domestic Partnership', categoryCode: '12' },
        { code: '12981', name: 'DCSS - UIFSA', categoryCode: '12' },
        { code: '24428', name: 'Dept. of Child Support Services DCSS', categoryCode: '12' },
        { code: '23861', name: 'Dissolution w/ Minor Children', categoryCode: '12' },
        { code: '23862', name: 'Dissolution w/o Minor Children', categoryCode: '12' },
        { code: '23863', name: 'DV Prevention w/ Minor Children', categoryCode: '12' },
        { code: '23864', name: 'DV Prevention w/o Minor Children', categoryCode: '12' },
        { code: '68056', name: 'Elder/Dependent Adult Abuse Prevention', categoryCode: '12' },
        { code: '106285', name: 'Elder/Dependent Adult Restraining Order Allowing Contact', categoryCode: '12' },
        { code: '101283', name: 'Emancipation: FL', categoryCode: '12' },
        { code: '13088', name: 'Establish Parental Relationship', categoryCode: '12' },
        { code: '68057', name: 'Habeas Corpus - Hague Convention', categoryCode: '12' },
        { code: '119382', name: 'Joint Petition for Dissolution w/ Minor Children Not Summary', categoryCode: '12' },
        { code: '119383', name: 'Joint Petition for Dissolution w/o Minor Children Not Summary', categoryCode: '12' },
        { code: '119384', name: 'Joint Petition for Legal Separation w/ Minor Children Not Summary', categoryCode: '12' },
        { code: '119385', name: 'Joint Petition for Legal Separation w/o Minor Children Not Summary', categoryCode: '12' },
        { code: '68058', name: 'Joint Petition for Summary Dissolution', categoryCode: '12' },
        { code: '23865', name: 'Legal Separation w/ Minor Children', categoryCode: '12' },
        { code: '23866', name: 'Legal Separation w/o Minor Children', categoryCode: '12' },
        { code: '101276', name: 'Non-Adoption: FL - Abandonment', categoryCode: '12' },
        { code: '23867', name: 'Nullity w/ Minor Children', categoryCode: '12' },
        { code: '23868', name: 'Nullity w/o Minor Children', categoryCode: '12' },
        { code: '13012', name: 'Other Family Law', categoryCode: '12' },
        { code: '68059', name: 'Reciprocal Case', categoryCode: '12' },
        { code: '68060', name: 'Register Out-of-State or Tribal Protective/Restraining Order', categoryCode: '12' },
        { code: '68061', name: 'Release of Confidential Marriage License/Certificate', categoryCode: '12' },
        { code: '68063', name: 'Surrogacy', categoryCode: '12' },
    ],
    // Juvenile Dependency — 6 types
    '14': [
        { code: '85209', name: 'Dependency: WIC 300 - Original', categoryCode: '14' },
        { code: '85210', name: 'Dependency: WIC 387 - Supplemental (Pursuant to WIC 328)', categoryCode: '14' },
        { code: '109269', name: 'Juvenile Reciprocal Case', categoryCode: '14' },
        { code: '85211', name: 'Non-Minor Dependent: Juvenile Dependency - 388(e)(1)', categoryCode: '14' },
        { code: '112336', name: 'Non-Minor Dependent: Juvenile Dependency - 388(f)', categoryCode: '14' },
        { code: '112383', name: 'Non-Minor Dependent: Juvenile Dependency - 388(f)', categoryCode: '14' },
    ],
    // Probate — 18 types
    '4': [
        { code: '56651', name: 'Conservatorship', categoryCode: '4' },
        { code: '24969', name: 'Decedent\'s Estate', categoryCode: '4' },
        { code: '56652', name: 'Guardianship', categoryCode: '4' },
        { code: '53555', name: 'Limited Conservatorship', categoryCode: '4' },
        { code: '47298', name: 'Minor\'s Compromise - Expedited', categoryCode: '4' },
        { code: '47297', name: 'Minor\'s Compromise', categoryCode: '4' },
        { code: '12833', name: 'Other Probate With At Least One Hearing', categoryCode: '4' },
        { code: '12834', name: 'Other Probate With No Hearing', categoryCode: '4' },
        { code: '106290', name: 'Roger S. Petition Hearing', categoryCode: '4' },
        { code: '12896', name: 'Trust', categoryCode: '4' },
        { code: '118618', name: 'WIC 5008(h)(1)(A) and (B) - Murphy Conservatorship', categoryCode: '4' },
        { code: '118619', name: 'WIC 5008(h)(1)(B) - Murphy Conservatorship', categoryCode: '4' },
        { code: '106291', name: 'WIC 5150 - Probable Cause Hearing', categoryCode: '4' },
        { code: '106292', name: 'WIC 5250/5270 - Certification Review Hearing', categoryCode: '4' },
        { code: '106293', name: 'WIC 5332 - Medication Capacity on WIC 5150', categoryCode: '4' },
        { code: '118620', name: 'WIC 5346 - Assisted Outpatient Treatment', categoryCode: '4' },
        { code: '118621', name: 'WIC 5350 - LPS Conservatorship', categoryCode: '4' },
        { code: '108981', name: 'WIC 5972 - CARE ACT', categoryCode: '4' },
    ],
    // Probate or Mental Health — 5 types
    '13': [
        { code: '118618', name: 'WIC 5008(h)(1)(A) and (B) - Murphy Conservatorship', categoryCode: '13' },
        { code: '118619', name: 'WIC 5008(h)(1)(B) - Murphy Conservatorship', categoryCode: '13' },
        { code: '118620', name: 'WIC 5346 - Assisted Outpatient Treatment', categoryCode: '13' },
        { code: '118621', name: 'WIC 5350 - LPS Conservatorship', categoryCode: '13' },
        { code: '108981', name: 'WIC 5972 - CARE ACT', categoryCode: '13' },
    ],
    // Small Claims — 1 type
    'SC': [
        { code: 'SC', name: 'Small Claims', categoryCode: 'SC' },
    ],
};
// Civil Unlimited — all Civil Limited types plus additional CU-specific types
LA_COUNTY_CASE_TYPES['CU'] = [
    ...LA_COUNTY_CASE_TYPES['LC'].map((t) => ({ ...t, categoryCode: 'CU' })),
    { code: '0402', name: 'Asbestos-PI/WD', categoryCode: 'CU' },
    { code: '4301', name: 'Civil Harassment with Damages', categoryCode: 'CU' },
    { code: '4201', name: 'Declaratory Relief Only', categoryCode: 'CU' },
    { code: '4304', name: 'Election Contest', categoryCode: 'CU' },
    { code: '4101', name: 'Insurance Coverage/Subrogation complex', categoryCode: 'CU' },
    { code: '1502', name: 'Labor Commissioner Appeals', categoryCode: 'CU' },
    { code: '2101', name: 'Partnership & Corporate Governance', categoryCode: 'CU' },
    { code: '4305', name: 'Petition for Change of Name/Gender', categoryCode: 'CU' },
    { code: '4306', name: 'Petition for Relief from Late Claim Law', categoryCode: 'CU' },
    { code: '2701', name: 'Racketeering RICO', categoryCode: 'CU' },
    { code: '3001', name: 'Toxic Tort/Environmental', categoryCode: 'CU' },
    { code: '4302', name: 'Workplace Harassment with Damages', categoryCode: 'CU' },
    { code: '0201', name: 'Writ - Administrative Mandamus', categoryCode: 'CU' },
    { code: '0202', name: 'Writ - Mandamus on Limited Court Case Matter', categoryCode: 'CU' },
    { code: '0203', name: 'Writ - Other Limited Court Case Review', categoryCode: 'CU' },
];
export const getCaseTypes = (categoryEfmCode) => {
    return LA_COUNTY_CASE_TYPES[categoryEfmCode] || [];
};
/**
 * JTI unlawful-detainer case-type codes (the Civil Limited 'LC' family:
 * Commercial 3101, Residential 3201, Post-Foreclosure 3401, Drugs 3801).
 * Walter R103: a UD filing must capture the defendant's mailing address.
 */
export const UNLAWFUL_DETAINER_CASE_TYPE_CODES = ['3101', '3201', '3401', '3801'];
/**
 * Detect an unlawful-detainer case type. Codes are not stable across sources
 * (mocks use 'CV_UD'; the JTI reference uses '3201' etc.), so the name prefix
 * is the primary detector with the known JTI code set as a fast path.
 */
export const isUnlawfulDetainerCaseType = (caseType) => {
    if (!caseType)
        return false;
    if (caseType.code && UNLAWFUL_DETAINER_CASE_TYPE_CODES.includes(caseType.code))
        return true;
    return /^unlawful detainer/i.test(caseType.name ?? '');
};
